import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_4 = { class: "tw-mt-2 tw-flex tw-w-full tw-justify-end tw-gap-2" }
const _hoisted_5 = {
  key: 1,
  class: "tw-flex-1 tw-text-left"
}
const _hoisted_6 = { class: "tw-break-words tw-break-all tw-text-sm" }
const _hoisted_7 = { class: "tw-text-xs tw-text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_StudioButtonGroup = _resolveComponent("StudioButtonGroup")!
  const _component_StudioConfirmationDialog = _resolveComponent("StudioConfirmationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass({
        'tw-group tw-w-full': true,
        'tw-p-2': _ctx.allowSelection,
        'hover:tw-opacity-75': _ctx.allowSelection && !_ctx.isRenamingUIVisible,
        'tw-bg-deep-orange-200 tw-p-2 hover:tw-bg-deep-orange-200 hover:tw-bg-opacity-70': _ctx.isSelected
      }),
      disabled: !_ctx.allowSelection || _ctx.isRenamingUIVisible,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectFillerSlideAsset && _ctx.handleSelectFillerSlideAsset(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass({
            'tw-aspect-video tw-h-10 tw-rounded tw-bg-cover tw-bg-center': true,
            'tw-mb-3': _ctx.isRenamingUIVisible
          }),
          style: _normalizeStyle({
            backgroundImage: `url(${_ctx.fillerSlideAsset.urls.image})`
          })
        }, null, 6),
        (_ctx.isRenamingUIVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRenameFillerSlideAsset && _ctx.handleRenameFillerSlideAsset(...args)), ["prevent"]))
              }, [
                _createVNode(_component_StudioInput, {
                  id: "filler-slide-asset-new-name-input",
                  ref: "newNameInput",
                  modelValue: _ctx.newName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newName) = $event)),
                  maxlength: 255,
                  required: ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_StudioButton, {
                    trackingId: "cancel-renaming-filler-slide-item-button",
                    size: "small",
                    variant: "outline",
                    disabled: _ctx.isRenaming,
                    onClick: _ctx.hideRenameUI
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_StudioButton, {
                    trackingId: "save-renaming-filler-slide-item-button",
                    size: "small",
                    type: "submit",
                    disabled: _ctx.isRenaming
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 32)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.fillerSlideAsset.name), 1),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.fillerSlideAsset.status === 'PROCESSING' || _ctx.fillerSlideAsset.status === 'NOT_GENERATED')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Processing... ")
                    ], 64))
                  : (_ctx.fillerSlideAsset.status === 'GENERATED')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Processed ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" Processing Stopped ")
                      ], 64))
              ])
            ])),
        (!_ctx.isRenamingUIVisible)
          ? (_openBlock(), _createBlock(_component_StudioButtonGroup, {
              key: 2,
              variant: "outline",
              size: "small",
              class: _normalizeClass(_ctx.alwaysShowActions ? '' : 'tw-hidden group-hover:tw-flex'),
              buttons: _ctx.actionButtons
            }, null, 8, ["class", "buttons"]))
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_1),
    (_ctx.isConfirmingDelete)
      ? (_openBlock(), _createBlock(_component_StudioConfirmationDialog, {
          key: 0,
          type: "error",
          heading: "Are you sure?",
          actionsDisabled: _ctx.isDeleting,
          message: `You are deleting the filler slide <b>${_ctx.fillerSlideAsset.name}</b>. This action cannot be undone.`,
          primaryActionTitle: _ctx.isDeleting ? 'Deleting...' : 'Delete',
          secondaryActionTitle: "Cancel",
          onPrimaryAction: _ctx.handleDeleteFillerSlideAsset,
          onSecondaryAction: _ctx.hideDeleteConfirmationDialog
        }, null, 8, ["actionsDisabled", "message", "primaryActionTitle", "onPrimaryAction", "onSecondaryAction"]))
      : _createCommentVNode("", true)
  ]))
}